<script setup lang="ts">
import type { DropdownMenuTriggerProps } from 'reka-ui';

import { DropdownMenuTrigger, useForwardProps } from 'reka-ui';

const props = withDefaults(defineProps<DropdownMenuTriggerProps>(), {
	as: 'div'
});

const forwardedProps = useForwardProps(props);
</script>

<template>
	<ClientOnly>
		<DropdownMenuTrigger class="outline-none" v-bind="forwardedProps">
			<slot />
		</DropdownMenuTrigger>
		<template #fallback>
			<component :is="props.as" class="outline-none" v-bind="forwardedProps">
				<slot />
			</component>
		</template>
	</ClientOnly>
</template>
